module.exports = __webpack_public_path__ + "media/images/sale_crm/user_settings-2b24bba71770081bd52e62be46b75ea4.svg";